import { render } from "./FPluginCalendar.vue?vue&type=template&id=23ff7fe5&scoped=true"
import script from "./FPluginCalendar.vue?vue&type=script&lang=js"
export * from "./FPluginCalendar.vue?vue&type=script&lang=js"

import "./FPluginCalendar.vue?vue&type=style&index=0&id=23ff7fe5&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ff7fe5"]])

export default __exports__